import Vue from 'vue'
import {isIdCardNo, validators} from './valid'
import {replaceSymbol} from './string'
import {localget, localset} from 'Utils/storage.js'
import {formatDate} from './dateUtil'
import {TRAIN_NEW_TO_OLD} from 'Utils/tools'
// 币种转换 CNY -> '人民币'
const currencyType = (currency) => {
  var currecncyType = localget('currecncyType')

  if (!currecncyType) {
    Vue.prototype.$api['common/getBClass']({parNo: 15900}).then(res => {
      var currecncyType = {}
      res.data.list.forEach((item) => {
        currecncyType[item.cName] = item.by1
      })
      localset('currecncyType', currecncyType)
    })

    return ''
  }
  if (!currency) return ''

  return currecncyType[currency]
}

// 转大写
const uppercase = (val) => {
  if (!val) {
    return
  }
  if (typeof (val) === 'string') {
    val = val.toUpperCase()
    return val
  } else {
    return val
  }
}

/**
 * 保留 ${bit} 位小数
 * 5 => 5.00
 */
const fixed = (val, bit) => {
  if (val && val != 0) {
    val = parseFloat(val)
    val = val.toFixed(bit)
    return val
  } else {
    return 0
  }
}

const substring = (str, start, end) => {
  return str ? str.substring(start, end) : ''
}

/**
 * 根据当前出行人 证件类型【cardType】 获取证件号码 并验证
 * 火车票专用
 * @param {Object: Travel} val 出行人信息
 */
const getIdNumber = (val) => {
  console.log('0', TRAIN_NEW_TO_OLD())
  if (!val.cardType && val.cardType) {
    val.cardType = val.cardType
  }
  console.log('val', val)
  if (!val.cardType || TRAIN_NEW_TO_OLD()['NI'].key == '1') {
    if (!val.cardNo) {
      let errMsg = `请核实${getName(val)}的身份证号码！`
      Vue.prototype.$toast(errMsg)
      throw new Error(errMsg)
    }
    return val.cardNo
  } else if (TRAIN_NEW_TO_OLD()['PP'].key == 'B') {
    if (!val.cardNo) {
      let errMsg = `请核实${getName(val)}的证件号码！`
      Vue.prototype.$toast(errMsg)
      throw new Error(errMsg)
    }
    return val.cardNo
  } else if (TRAIN_NEW_TO_OLD()['GA'].key == 'C') {
    if (!val.cardNo) {
      let errMsg = `请核实${getName(val)}的证件号码！`
      Vue.prototype.$toast(errMsg)
      throw new Error(errMsg)
    }
    return val.cardNo
  } else if (TRAIN_NEW_TO_OLD()['TW'].key == 'G') {
    if (!val.cardNo) {
      let errMsg = `请核实${getName(val)}的证件号码！`
      Vue.prototype.$toast(errMsg)
      throw new Error(errMsg)
    }
    return val.cardNo
  } else if (TRAIN_NEW_TO_OLD()['FI'].key == 'H') {
    if (!val.cardNo) {
      let errMsg = `请核实${getName(val)}的证件号码！`
      Vue.prototype.$toast(errMsg)
      throw new Error(errMsg)
    }
    return val.cardNo
  } else if (TRAIN_NEW_TO_OLD()['HM'].key == '2') {
    if (!val.cardNo) {
      let errMsg = `请核实${getName(val)}的证件号码！`
      Vue.prototype.$toast(errMsg)
      throw new Error(errMsg)
    }
    return val.cardNo
  } else {
    if (!val.cardNo) {
      let errMsg = `请核实${getName(val)}的证件号码！`
      Vue.prototype.$toast(errMsg)
      throw new Error(errMsg)
    }
    return val.cardNo
  }
}

const getIdNumber2 = (val) => {
  if (!val.cardType || val.cardType == '1') {
    return val.idNumber
  } else if (val.cardType == 'B') {
    return val.passport
  } else {
    return val.otherNumber
  }
}

const getEmail = (val) => {
  if (val.phoneNumber && !val.email) return

  if ((val.cardType && val.cardType != '1') && !validators.email(val.email).valid) {
    let errMsg = `请核实${getName(val)}的邮箱地址！`
    Vue.prototype.$toast(errMsg)
    throw new Error(errMsg)
  } else {
    return val.email
  }
}

/**
 * 获取当前出行人姓名
 * 有可能所选出行人为附属员工，需要优先取chName
 * @param {Object: Travel} val 出行人信息
 */
const getName = (val) => {
  if (val.clkFlag == 1 || val.chName || val.contactsId) {

    return val.chName || val.enName
  } else if (val.cxrName) {
    return val.cxrName
  } else if (val.psgName) {
    return val.psgName
  } else if (val.name) {
    return val.name
  }
  return val.empName
}

/**
 * 获取当前出行人ID
 * 有可能所选出行人为常用联系人，附属员工，出差申请单的出行人
 * @param {Object: Travel} val 出行人信息
 */
const getId = (val) => {
  if (val.conempId) {
    return val.conempId
  } else if (val.personId) {
    return val.personId
  } else if (val.contactsId) {
    return val.contactsId
  } else if (val.id) {
    return val.id
  }
  return val.empId
}

/**
 * 根据出行人的证件类型，转换对应接口需要的字段
 * 适用机票
 * @param {Object: Travel} val 出行人信息
 */
const getIdType = (val) => {
  if (!val.cardType || val.cardType == 1) {
    return '1'
  } else if (val.cardType == 2) {
    return 'B'
  } else {
    return 'C'
  }
}
// 只获取 周
const week = (val) => {
  if (val) {
    return formatDate(val).week
  }
}
// 获取 证件名称
const cardType = (val) => {
  var info = '身份证'
  if (val) {
    var obj = {
      'NI': '身份证',
      'PP': '护照',
      'ID': '其他',
      'JR': '军人证',
      'HX': '回乡证',
      'TB': '台胞证',
      'HK': '户口薄',
      'CS': '出生证明',
      'WG': '外国人永久居留身份证',
      'GA': '港澳台居民居住证',
      'GT': '港澳通行证',
      'TT': '台湾通行证'
    }
    if (obj[val]) {
      return obj[val]
    }
    return info
  }
  return info
}
// 简化机场名称
const airportName = (val) => {
  if (val) {
    val = val.replace(/国际机场|机场/g, '')
    return val
  }
  return val
}

const filters = {
  currencyType,
  uppercase,
  fixed,
  substring,
  getIdNumber,
  getIdNumber2,
  getIdType,
  getName,
  getId,
  cardType,
  replaceSymbol,
  week,
  airportName,
  getEmail
}

Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

export default filters
